import Vue from 'vue';
import Vuex from 'vuex';
import VuexORM from '@vuex-orm/core';
import VuexORMAxios from '@michielvdanker/plugin-axios';
import VuexORMisDirtyPlugin from '@michielvdanker/plugin-change-flags';
import UrlReadWrite from './util/query-sync/url-read-write';

import { Scope } from './models/match/Scope';
import { ScopeConfiguration } from './models/match/ScopeConfiguration';
import { ScopeProfile } from './models/match/ScopeProfile';
import { User } from './models/User';

import registration from './modules/registration/store';

// Init Vuex
Vue.use(Vuex);  

// Create new instance of Database
const database = new VuexORM.Database();

// Register Models and Modules
database.register(Scope);
database.register(ScopeConfiguration);
database.register(ScopeProfile);
database.register(User);

// Init Axios plugin
VuexORM.use(VuexORMisDirtyPlugin);
VuexORM.use(VuexORMAxios, {
  database,

  /**
   * Axios Request Config
   * @see {@link https://github.com/vuex-orm/plugin-axios#axios-request-config}
   */
  http: {
    baseURL: '/api/v2',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },

    /**
     * Default on Response
     * @param {object} response
     */
    onResponse (response) {
      /**
       * Using $resetDirty flag to reset the $isDirty flag when we receive data from the server
       */
      response.data.$resetDirty = true;
      return response.data;
    }
  }
});

// Create the store
const store = new Vuex.Store({
  plugins: [VuexORM.install(database)],

  modules: {
    UrlReadWrite,
    registration
  }
});

export default store;
